import React, { useState, useEffect } from "react";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Container, CardContent, Button, Grid, Divider, TextField, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import axios from 'axios';
import HOST_URL from '../../../utils/Url';
import { toast } from "react-toastify";
import Autocomplete from "@mui/material/Autocomplete";
import ToastApp from "../../../ToastApp";
import Chip from '@mui/material/Chip';
import { DataGrid, GridToolbar, GridColDef } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/Edit";
import ChevronRightIcon from "@mui/icons-material/Edit";
// import TreeView from '@mui/lab/TreeView';
// import TreeItem from '@mui/lab/TreeItem';
import { TreeView } from '@mui/x-tree-view/TreeView';

import { TreeItem, treeItemClasses } from '@mui/x-tree-view/TreeItem';
//import { TreeView, TreeItem } from '@mui/lab';
import { FormControlLabel, Checkbox } from '@mui/material';
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { RichTreeView } from "@mui/x-tree-view";
import { styled } from '@mui/material/styles';
import api from "../../../utils/Url";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}



function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {

  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
// const treedata = [
//   {
//     id: 1,
//     name: 'Parent 1',
//     children: [
//       { id: 2, name: 'Child 1' },
//       { id: 3, name: 'Child 2' },
//     ],
//   },
//   {
//     id: 4,
//     name: 'Parent 2',
//     children: [
//       { id: 5, name: 'Child 3' },
//       { id: 6, name: 'Child 4' },
//     ],
//   },
// ];

export default function BasicTabs() {

  const [value, setValue] = React.useState(0);
  const back = useNavigate();
  let navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [toaster, setToaster] = useState(false);
  const requiredFields = ['dept_id', 'designation_name'];
  const [option, setOption] = useState([{ value: "-1", label: t("text.selectLoc") }]);
  const [tabledata, setTabledata] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [columns, setColumns] = useState<any>([]);
  const [treedata, setTreedata] = useState<any>([]);

  const validationSchema = Yup.object({
    //   designation_name: Yup.string().test(
    //   'required', 
    //   t('text.reqdeadditem'), 
    //   function (value:any) {
    //     return value && value.trim() !== ''; 
    //   }
    // ),
    dept_id: Yup.string().test(
      'required',
      t('text.reqdAlias'),
      function (value: any) {
        return value && value.trim() !== '';
      }
    ),
  });

  useEffect(() => {

    getlocationitem();
    getMappedLocationData();
    fetchMappedLocationData();


  }, [])
  const getlocationitem = () => {
    const collectData = {
      "id": -1,
    };
    api
      .post(`Location/GetLocation`, collectData)
      .then((res) => {
        const arr: any = [];
        console.log("result" + JSON.stringify(res.data.data));

        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["locationObject"],
            value: res.data.data[index]["id"]
          });
        }
        setOption(arr);
      });
  };
  const getMappedLocationData = () => {
    const collectData = {
      "id": -1,
    };
    api
      .post(`LocationItems/GetLocationItemsHierarchical`, collectData)
      .then((res) => {
        const arr: any = [];
        console.log("result" + JSON.stringify(res.data.data));
        if (res.data.data.length > 0) {
          setTreedata(res.data.data);
        }
      });
  };

  const Addmappedlocation = () => {
    const arr: any = [];

    for (let index = 0; index < checked.length; index++) {
      const element = checked[index];
      arr.push({
        id: checked[index],
        locationObjectId: 0
      });

    }
    const collectData = {
      "id": -1,
      "childlocation": arr
    };
    api
      .post(`LocationItems/AddUpdateMappedLocationItems`, collectData)
      .then((response) => {
        if (response.data.isSuccess) {
          setToaster(false);
          toast.success(response.data.mesg);
          setChecked([]);
        } else {
          setToaster(true);
          toast.error(response.data.mesg);
        }
      });
  };

  const AddlocationItem = () => {
    const arr: any = [];

    for (let index = 0; index < checked.length; index++) {
      const element = checked[index];
      arr.push({
        id: checked[index],
        locationObjectId: 0
      });

    }
    const collectData = {
      "id": -1,
      "locationObjectId": formik.values.locationObjectId,
      "parentId": formik.values.parentId,
      "locationObjectItem": formik.values.locationObjectItem,
      "inst_Id": formik.values.inst_Id,
      "locationAliasItem": formik.values.locationAliasItem,
      "fromNo": formik.values.fromNo,
      "toNo": formik.values.toNo,

    };
    api
      .post(`LocationItems/AddUpdateLocationItems`, collectData)
      .then((response) => {
        if (response.data.isSuccess) {
          setToaster(false);
          toast.success(response.data.mesg);
          getlocationitem();
        } else {
          setToaster(true);
          toast.error(response.data.mesg);
        }
      });
  };


  const formik = useFormik({
    initialValues: {
      id: -1,
      locationObjectId: 0,
      parentId: 0,
      locationObjectItem: "",
      inst_Id: "1",
      locationAliasItem: "",
      fromNo: 0,
      toNo: 0
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {


    }
  });

  const fetchMappedLocationData = async () => {
    try {
      const collectData = {
        id: -1,

      };
      console.log("collectData", collectData)
      const response = await api.post(
        `LocationItems/GetMappedLocation`,
        collectData
      );
      console.log("result ", response.data.data)
      const data = response.data.data;
      const zonesWithIds = data.map((emp: any, index: any) => ({
        ...emp,
        serialNo: index + 1,
        id: emp.id,
      }));


      setTabledata(zonesWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "actions",
            headerClassName: "MuiDataGrid-colCell",
            headerName: t("text.Action"),
            width: 150,

            renderCell: (params) => {
              return [
                <Stack
                  spacing={1}
                  direction="row"
                  sx={{ alignItems: "center", marginTop: "5px" }}
                >
                  {/* {permissionData?.isEdit ? ( */}
                  <EditIcon
                    style={{
                      fontSize: "20px",
                      color: "blue",
                      cursor: "pointer",
                    }}
                    className="cursor-pointer"
                  //onClick={() => routeChangeEdit(params.row)}
                  />


                </Stack>,
              ];
            },
          },

          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "location_Path",
            headerName: t("text.LocationPath"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "location",
            headerName: t("text.Location"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },


        ];
        setColumns(columns as any);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));



  const [checked, setChecked] = useState<any>([]);

  const handleToggle = (id: number) => () => {
    const currentIndex = checked.indexOf(id);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(id);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    console.log("newChecked", newChecked);
    setChecked(newChecked);
  };
  const CustomTreeItem = styled(TreeItem)({
    [`& .${treeItemClasses.iconContainer}`]: {
      '& .close': {
        opacity: 0.3,
      },
    },
  });
  const renderTree = (nodes: any) => (
    console.log("nodes.id", nodes.id),
    <CustomTreeItem
      key={nodes.id}
      itemId={String(nodes.id)}
      //label={nodes.locationObjectItem}
      label={
        // Array.isArray(nodes.childLocI)?nodes.locationObjectItem:
        <FormControlLabel
          control={
            <Checkbox
              checked={checked.indexOf(nodes.id) !== -1}
              onChange={handleToggle(nodes.id)}

            />
          }
          label={nodes.locationObjectItem}
        />
      }
    >
      {Array.isArray(nodes.childLocI)
        ? nodes.childLocI.map((node: any) => renderTree(node))
        : null}
    </CustomTreeItem  >
  );

  // const renderTree = (nodes:any) => (
  //     console.log("nodes.id",nodes.id),
  //     <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
  //         <FormControlLabel
  //           control={
  //             <Checkbox
  //               checked={checked.indexOf(nodes.id) !== -1}
  //               onChange={handleToggle(nodes.id)}
  //             />
  //           }
  //           label={nodes.locationObjectItem}
  //         />
  //       {Array.isArray(nodes.childLocI)
  //         ? nodes.childLocI.map((node:any) => renderTree(node))
  //         : null}
  //         </Box>
  //   );


  return (
    <Container>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#FFFFFF",
          borderRadius: "5px",
          border: ".5px solid #ff7722",
          marginTop: "3vh",
        }}
      >
        <ToastApp />
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500, marginTop: "10px" }}
          >
            {/* CREATE LOCATION ITEM */}
            {t("text.LocationItem")}

          </Typography>
          <Grid xs={4} sm={12} item>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: "blue",
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label={t("text.LocationObjectItems")} {...a11yProps(0)} />
                <Tab label={t("text.Mapping")} {...a11yProps(1)} />
                {/* <Tab label="Item Three" {...a11yProps(2)} /> */}
              </Tabs>
            </Box>
            <form onSubmit={formik.handleSubmit}>
              <CustomTabPanel value={value} index={0}>
                {toaster === false ? "" : <ToastApp />}
                <Grid item xs={12} container spacing={2}>
                  <Grid xs={12} sm={3.3} item>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={option}
                      fullWidth
                      // value={
                      //   option.find(
                      //     (option) => option.value === formik.values.id
                      //   ) || null
                      // }
                      size="small"
                      onChange={(event: any, newValue: { value: any; } | null) => {
                        if (newValue == null) {
                          formik.setFieldValue("parentId", "");
                        }
                        else {
                          console.log(newValue?.value);
                          formik.setFieldValue("parentId", newValue?.value);
                          formik.setFieldTouched("parentId", true);
                          formik.setFieldTouched("parentId", false);
                        }

                      }}
                      renderInput={(params: any) => (
                        <TextField {...params} label={
                          <span>
                            {t("text.selectParntLoc")} {" "}
                            {requiredFields.includes('parentId') && (
                              <span style={{ color: formik.values.parentId ? 'green' : 'red' }}>*</span>
                            )}
                          </span>
                        } />
                      )}
                    />
                    {formik.touched.parentId && formik.errors.parentId ? (
                      <div style={{ color: "red", margin: "5px" }}>{formik.errors.parentId}</div>
                    ) : null}
                  </Grid>
                  <Grid xs={12} sm={3.3} item>

                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={option}
                      fullWidth
                      // value={
                      //   option.find(
                      //     (option) => option.value === formik.values.id
                      //   ) || null
                      // }
                      size="small"
                      onChange={(event: any, newValue: { value: any; } | null) => {
                        if (newValue == null) {
                          formik.setFieldValue("locationObjectId", "");
                        }
                        else {
                          console.log(newValue?.value);
                          formik.setFieldValue("locationObjectId", newValue?.value);
                          formik.setFieldTouched("locationObjectId", true);
                          formik.setFieldTouched("locationObjectId", false);
                        }

                      }}
                      renderInput={(params: any) => (
                        <TextField {...params} label={
                          <span>
                            {t("text.selectLoc")} {" "}
                            {requiredFields.includes('locationObjectId') && (
                              <span style={{ color: formik.values.locationObjectId ? 'green' : 'red' }}>*</span>
                            )}
                          </span>
                        } />
                      )}
                    />
                    {formik.touched.locationObjectId && formik.errors.locationObjectId ? (
                      <div style={{ color: "red", margin: "5px" }}>{formik.errors.locationObjectId}</div>
                    ) : null}
                  </Grid>


                  <Grid item lg={3.3} xs={12}>
                    <TextField
                      id="locationObjectItem"
                      name="locationObjectItem"
                      label={
                        <span>
                          {t("text.enterAddItem")}{" "}{requiredFields.includes('locationObjectItem') && (
                            <span style={{ color: formik.values.locationObjectItem ? 'green' : 'red' }}>*</span>
                          )}
                        </span>
                      }
                      value={formik.values.locationObjectItem}
                      placeholder={t("text.enterAddItem")}
                      size="small"
                      fullWidth
                      style={{
                        backgroundColor: 'white',
                        borderColor: formik.touched.locationObjectItem && formik.errors.locationObjectItem ? 'red' : 'initial',
                      }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.locationObjectItem && formik.errors.locationObjectItem ? (
                      <div style={{ color: "red", margin: "5px" }}>{formik.errors.locationObjectItem}</div>
                    ) : null}
                  </Grid>

                  <Grid item lg={2} xs={12}>
                    <Grid>
                      <Button
                        //type="submit"
                        // fullWidth
                        style={{
                          backgroundColor: "#059669",
                          color: "white",
                          marginTop: "2px",
                        }}
                        onClick={(e: any) => AddlocationItem()}
                      >
                        {t("text.save")}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>

                <br />
                <Divider><Chip label="Or" size="small" /></Divider>
                <br />
                <Grid item xs={12} container spacing={2}>
                  <Grid item lg={3.3} xs={12}>
                    <TextField
                      id="locationAliasItem"
                      name="locationAliasItem"
                      label={
                        <span>
                          {t("text.enterAlias")}{" "}{requiredFields.includes('locationAliasItem') && (
                            <span style={{ color: formik.values.locationAliasItem ? 'green' : 'red' }}>*</span>
                          )}
                        </span>
                      }
                      value={formik.values.locationAliasItem}
                      placeholder={t("text.enterAlias")}
                      size="small"
                      fullWidth
                      style={{
                        backgroundColor: 'white',
                        borderColor: formik.touched.locationAliasItem && formik.errors.locationAliasItem ? 'red' : 'initial',
                      }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.locationAliasItem && formik.errors.locationAliasItem ? (
                      <div style={{ color: "red", margin: "5px" }}>{formik.errors.locationAliasItem}</div>
                    ) : null}
                  </Grid>
                  <Grid item lg={3.3} xs={12}>
                    <TextField
                      id="fromNo"
                      name="fromNo"
                      label={
                        <span>
                          {t("text.enterFrom")}{" "}{requiredFields.includes('fromNo') && (
                            <span style={{ color: formik.values.fromNo ? 'green' : 'red' }}>*</span>
                          )}
                        </span>
                      }
                      value={formik.values.fromNo}
                      placeholder={t("text.enterDesName")}
                      size="small"
                      fullWidth
                      style={{
                        backgroundColor: 'white',
                        borderColor: formik.touched.fromNo && formik.errors.fromNo ? 'red' : 'initial',
                      }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.fromNo && formik.errors.fromNo ? (
                      <div style={{ color: "red", margin: "5px" }}>{formik.errors.fromNo}</div>
                    ) : null}
                  </Grid>
                  <Grid item lg={3.3} xs={12}>
                    <TextField
                      id="toNo"
                      name="toNo"
                      label={
                        <span>
                          {t("text.enterTo")}{" "}{requiredFields.includes('toNo') && (
                            <span style={{ color: formik.values.toNo ? 'green' : 'red' }}>*</span>
                          )}
                        </span>
                      }
                      value={formik.values.toNo}
                      placeholder={t("text.enterDesName")}
                      size="small"
                      fullWidth
                      style={{
                        backgroundColor: 'white',
                        borderColor: formik.touched.toNo && formik.errors.toNo ? 'red' : 'initial',
                      }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.toNo && formik.errors.toNo ? (
                      <div style={{ color: "red", margin: "5px" }}>{formik.errors.toNo}</div>
                    ) : null}
                  </Grid>
                  <Grid item lg={2} xs={12}>
                    <Grid>
                      <Button
                        // type="submit"
                        // fullWidth
                        style={{
                          backgroundColor: "#1F75FE",
                          color: "white",
                          marginTop: "2px",
                        }}
                        onClick={(e: any) => AddlocationItem()}
                      >
                        {t("text.generate")}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <Grid container spacing={2}>
                  <Grid item sm={6}>
                    <Typography
                      variant="h5"
                      textAlign="center"
                      style={{ fontSize: "18px", fontWeight: 500, marginTop: "10px" }}
                    >
                      {t("text.LocationItem")}

                    </Typography>
                    <Divider></Divider>
                    <Grid item sm={12}>
                      <Box>
                        <div>
                          <SimpleTreeView
                          // defaultCollapseIcon={<ExpandMoreIcon />}
                          //defaultExpandIcon={<ChevronRightIcon />}
                          // multiSelect={true}      
                          >

                            {Array.isArray(treedata)
                              ? treedata.map((node: any) => renderTree(node)) : null}
                          </SimpleTreeView>
                        </div>

                      </Box>
                      <Grid container spacing={5} style={{ top: "10px" }} position={"relative"}>
                        <Grid item lg={4} sm={4} xs={6}>
                          <Button
                            type="reset"
                            fullWidth
                            style={{
                              backgroundColor: "#37d67a",
                              color: "white",
                              marginTop: "10px",
                              // marginLeft:"50px",             
                            }}
                            onClick={(e: any) => { Addmappedlocation() }}
                          >
                            {t("text.Mapped")}
                          </Button>
                        </Grid>
                        <Grid item lg={4} sm={4} xs={6}>
                          <Button
                            type="reset"
                            fullWidth
                            style={{
                              backgroundColor: "#F43F5E",
                              color: "white",
                              marginTop: "10px",
                              // marginLeft:"50px",             
                            }}
                          // onClick={(e:any) =>{ Addmappedlocation()}}
                          >
                            {t("text.Unmapped")}
                          </Button>
                        </Grid>
                        <Grid item lg={4} sm={4} xs={6}>
                          <Button
                            type="reset"
                            fullWidth
                            style={{
                              backgroundColor: "#2ccce4",
                              color: "white",
                              marginTop: "10px",
                              // marginLeft:"50px",             
                            }}
                            onClick={(e: any) => { setChecked([]) }}
                          >
                            {t("text.reset")}
                          </Button>
                        </Grid>
                      </Grid>

                    </Grid>



                  </Grid>
                  <Grid item sm={6}>
                    <Typography
                      variant="h5"
                      textAlign="center"
                      style={{ fontSize: "18px", fontWeight: 500, marginTop: "10px" }}
                    >
                       {t("text.MappedLocation")}
                      {/* {t("text.LocationItem")} */}

                    </Typography>
                    <Divider></Divider>
                    <Grid item sm={12} >
                      <div style={{ width: "100%", backgroundColor: "#FFFFFF" }}>
                        <DataGrid
                          rows={tabledata}
                          columns={adjustedColumns}
                          autoHeight
                          slots={{
                            toolbar: GridToolbar,
                          }}
                          rowSpacingType="border"
                          pagination={true}
                          pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                            value: size,
                            label: `${size}`,
                          }))}
                          initialState={{
                            pagination: { paginationModel: { pageSize: 5 } },
                          }}
                          slotProps={{
                            toolbar: {
                              showQuickFilter: true,
                            },
                          }}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </CustomTabPanel>
            </form>



          </Box>
        </CardContent>
      </div>
    </Container>
  );
}